import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface AccountSummaryTooltipProps {
  openLeft: boolean
  isBudget: boolean
  isLimitedBudget: boolean
}

const AccountSummaryTooltip: React.FC<AccountSummaryTooltipProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <Tooltip openLeft={props.openLeft}>
      <p>
        {!props.isBudget &&
          translate(
            "${accountSummary} gives you an overview of how much spending power you've issued and, of that, what has been spent.",
            {
              accountSummary: (
                <span
                  css={css`
                    font-family: ${styleConstants.fontFamilies.medium};
                  `}
                >
                  {translate('Account Summary')}
                </span>
              ),
            },
          )}
        {props.isBudget &&
          !props.isLimitedBudget &&
          translate(
            '${budgetSummary} gives you an overview of how much spending power has been issued and, of that, what has been spent.',
            {
              budgetSummary: (
                <span
                  css={css`
                    font-family: ${styleConstants.fontFamilies.medium};
                  `}
                >
                  {translate('Budget Summary')}
                </span>
              ),
            },
          )}
        {props.isBudget &&
          props.isLimitedBudget &&
          translate(
            '${budgetSummary} gives you an overview of how much spending power has been issued and how much of the budget remains. ${remaining} tells you how much of the budget is left.',
            {
              budgetSummary: (
                <span
                  css={css`
                    font-family: ${styleConstants.fontFamilies.medium};
                  `}
                >
                  {translate('Budget Summary')}
                </span>
              ),
              remaining: (
                <span
                  css={css`
                    font-family: ${styleConstants.fontFamilies.medium};
                  `}
                >
                  {translate('Remaining')}
                </span>
              ),
            },
          )}
      </p>
      <p
        css={css`
          margin-top: 12px;
        `}
      >
        {translate(
          '${currentExposure} represents the sum of all available credit across active virtual cards. Any inactive virtual cards will not be reflected in this amount.',
          {
            currentExposure: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                {translate('Current Exposure')}
              </span>
            ),
          },
        )}
      </p>
    </Tooltip>
  )
}

export default AccountSummaryTooltip
